import { capitalize } from 'lodash';

export default function getCapitalizedSubscriptionInterval(
  interval,
  intervalCount,
) {
  let intervalText = interval;

  // add 's' to pluralize if intervalText hasn't been edited
  if (intervalText === interval && intervalCount && intervalCount > 1) {
    intervalText = `${intervalText}s`;
  }

  // combine interval text with intervalCountText (or 'Every')
  if (intervalCount && intervalCount > 1) {
    intervalText = ['every', intervalCount, intervalText].join(' ');
  }

  if (intervalCount === 1) {
    switch (interval) {
      case 'day':
        intervalText = 'daily';
        break;
      case 'week':
        intervalText = 'weekly';
        break;
      case 'month':
        intervalText = 'monthly';
        break;
      case 'year':
        intervalText = 'yearly';
        break;
      default:
        break;
    }
  }

  intervalText = capitalize(intervalText);

  return intervalText;
}
